import { render, staticRenderFns } from "./DocumentReject.vue?vue&type=template&id=2af90f85&"
import script from "./DocumentReject.vue?vue&type=script&lang=js&"
export * from "./DocumentReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports